import HeroBottom from './bottom/script';
import HeroGeneric from './generic/script';
import HeroHome from './home/script';
import HeroStandard from './standard/script';

export default {
	[HeroBottom.selector]: HeroBottom,
	[HeroGeneric.selector]: HeroGeneric,
	[HeroHome.selector]: HeroHome,
	[HeroStandard.selector]: HeroStandard
};
